
export function shouldHideIndyTrolleyAttachment(isSingleTrolleyAttachment: boolean, sideValue: string | undefined, productName: string): boolean {
  if (!isSingleTrolleyAttachment) {
    return false
  }

  const requiresTrolleyPair = String(sideValue)?.toLowerCase() === 'dual'
  const isDualTrolleyAttachment = productName.toLowerCase()?.includes('(pair)')
  
  // Hide single trolley attachment when "Dual" is selected for the side
  if (requiresTrolleyPair && !isDualTrolleyAttachment) {
    return true
  }
  
  // Hide dual trolley attachment when "Left" or "Right" side selected
  if (!requiresTrolleyPair && isDualTrolleyAttachment) {
    return true
  }

  return false
}
